import { FC } from 'react';
import { IoCashOutline, IoTimeOutline } from 'react-icons/io5';

import { Group, Text } from '@mantine/core';

import { Component } from 'models';

import { useComponentMeta } from 'hooks/use-component-meta';

const ComponentOverviewHitAveragePrice: FC<{ component: Component }> = ({ component }) => {
    const { price, leadTime } = useComponentMeta(component);

    if (!price && !leadTime) {
        return null;
    }

    return (
        <Group gap={4} wrap="nowrap">
            {price ? <IoCashOutline size={12} /> : <IoTimeOutline size={12} />}
            <Text fz="sm" fw={600}>
                {price && `Avg. ${price}`}
                {leadTime && (
                    <Text span inherit fw={400} c="dimmed">
                        {price ? ' · ' : 'Lead time: '}
                        {leadTime}
                    </Text>
                )}
            </Text>
        </Group>
    );
};

export { ComponentOverviewHitAveragePrice };
